import { api } from '../axios'
import type {
  ApiResponse,
  ChatConversationSummary,
  ChatConversationWithMessages,
  ChatStatusResponse,
  SendMessageResponse,
} from '@/types'
import type { SendMessageData } from './chat.static'

export const chatService = {
  async getStatus(): Promise<ChatStatusResponse> {
    const response = await api.get<ApiResponse<ChatStatusResponse>>('/chat/status')
    return response.data.data
  },

  async sendMessage(data: SendMessageData): Promise<SendMessageResponse> {
    const response = await api.post<ApiResponse<SendMessageResponse>>('/chat', data)
    return response.data.data
  },

  async getConversations(): Promise<ChatConversationSummary[]> {
    const response = await api.get<ApiResponse<ChatConversationSummary[]>>('/chat/conversations')
    return response.data.data
  },

  async getConversation(id: string): Promise<ChatConversationWithMessages> {
    const response = await api.get<ApiResponse<ChatConversationWithMessages>>(
      `/chat/conversations/${id}`
    )
    return response.data.data
  },

  async deleteConversation(id: string): Promise<void> {
    await api.delete(`/chat/conversations/${id}`)
  },
}
